import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import actions from '../../redux/actions';
import InventoryUtils from '../../utils/inventory-utils';
import _ from 'lodash';
import getSearchTableColumns from './search-table-settings';
import ReactTable from 'react-table';

class InventoryDataTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inventoryDataFiltered: [],
            status: -1,
            ratePlanId: null,
            loading: false
        };
    }

    componentWillReceiveProps(nextProps) {
        let inventoryDataFiltered = InventoryUtils.filterData(nextProps.model.inventorySearchData, this.props);
        this.setState({ inventoryDataFiltered });
    }

    onDeleteClicked(rate) {
        this.props.actions.deleteRatePlan(rate.id);
    }

    render() {
        let inventoryDataFiltered = _.orderBy(this.state.inventoryDataFiltered, [ 'inventory.from' ]);

        return (
            <ReactTable
                className="top10"
                data={inventoryDataFiltered}
                defaultFilterMethod={(filter, row) =>
                    String(row[filter.id]).toLowerCase().startsWith(filter.value.toLowerCase())}
                columns={getSearchTableColumns(this)}
                defaultPageSize={10}
                style={{ fontSize: '12px' }}
            />
        );
    }
}

InventoryDataTable.defaultProps = {
    results: {
        inventory: []
    }
};

function mapStateToProps(state) {
    let pager = {
        pageSize: 10,
        totalPages: 0,
        pageNumber: 0,
        visiblePages: 9,
        titles: { first: 'First', last: 'Last' }
    };

    let results = state.inventory;
    if (results) {
        Object.assign(pager, {
            pageNumber: results.pageNumber - 1,
            totalPages: Math.ceil(Math.min(results.totalItemCount / pager.pageSize, 10000 / pager.pageSize))
        });
    }
    return {
        results: results,
        pager: pager,
        token: state.oidc.user !== null ? state.oidc.user.id_token : '',
        settings: state.settings,
        model: state.model
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(InventoryDataTable);
